import React, { useEffect, useState } from "react";
import { fetchTitles } from "../Database/saved-db";
import { Grid, Card, CardContent, Typography, IconButton } from "@mui/material";
import { useNavigate } from "react-router-dom";
import DeleteIcon from "@mui/icons-material/Delete";
import { deleteTitle } from "../Database/saved-db";
import { Title } from "../models/calculation";
import { LoanData } from "../models/loan-comparison";
import { fetchLoans } from "../Database/loan-comparisonDB";
import { deleteLoan } from "../Database/loan-comparisonDB";
import { RecurringDeposit } from "../models/recurring-deposit";
import { deleteRecurringDeposit,fetchRecurringDeposits,} from "../Database/recurring-deposit";
import { SIP } from "../models/sip";
import { deleteSIP, fetchSIPs } from "../Database/systematic-investment-plan";
import { SWPData } from "../models/swp";
import { fetchSWP } from "../Database/swp-db";
import { deleteSWP } from "../Database/swp-db";
import { deleteFD, fetchFDs } from "../Database/fixed-deposit";
import { FixedDeposit } from "../models/fixed-deposit";
import { GoalSIPData } from "../models/goal-sip";
import { deletegoalSIP, fetchgoalSIP } from "../Database/goal-sipDB";
import { EMI } from "../models/emi";
import { deleteEMI, fetchEMIs } from "../Database/emi";
import { StepUpSIP } from "../models/stepup-sip";
import { deleteStepUpSIP, fetchStepUpSIPs } from "../Database/stepup-sip";
import { InterestCalculation } from "../models/interest";
import { deleteInterestCalculation, fetchInterestCalculations } from "../Database/interest";
import '../assets/css/saved-calculation.css';
import DeleteSnackbar from "../utils/delete-snackbar";
type DeleteType = 'title' | 'loan' | 'recurringDeposit' | 'sip'| 'swp' | 'fixedDeposit' | 'goalSIP' | 'emi' | 'stepUpSIP' | 'interest'; 

const SavedCalculations: React.FC = () => {
  const [titles, setTitles] = useState<any[]>([]);
  const [loans, setLoans] = useState<any[]>([]);
  const [swps, setSWPS] = useState<any[]>([]);
  const [fixedDeposits, setFixedDeposit] = useState<any[]>([]);
  const [recurringDeposits, setRecurringDeposits] = useState<
  any[]
  >([]);
  const [SIPs, setSIP] = useState<any[]>([]);
  const [goalSips, setGoalSIP] = useState<any[]>([]);
  const [EMIs, setEmi] = useState<any[]>([]);
  const [StepUpSIPs, setStepUpSIP] = useState<any[]>([]);
  const [interests, setInterest] = useState<any[]>([]);
  const [hoveredEmiId, setHoveredEmiId] = useState<number | null>(null);
  const [hoveredRDId, setHoveredRDId] = useState<number | null>(null);
  const [hoveredSWPId, setHoveredSWPId] = useState<number | null>(null);
  const [hoveredFDId, setHoveredFDId] = useState<number | null>(null);
  const [hoveredLumsumId, setHoveredLumsumId] = useState<number | null>(null);
  const [hoveredIntId, setHoveredIntId] = useState<number | null>(null);
  const [hoveredSipId, setHoveredSipId] = useState<number | null>(null);
  const [hoveredStepupId, setHoveredStepupId] = useState<number | null>(null);
  const [hoveredSipGoalId, setHoveredSipGoalId] = useState<number | null>(null);
  const [hoveredLoanId, setHoveredLoanId] = useState<number | null>(null);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [itemIdToDelete, setItemIdToDelete] = useState<number | null>(null);
  const [deleteType, setDeleteType] = useState<DeleteType | null>(null);


 const navigate = useNavigate();

  useEffect(() => {
    const getData = async () => {
      try {
        const [
          titlesFromDb,
          loansFromDb,
          depositsFromDb,
          swpsFromDb,
          fixedFromDb,
          goalSipFromDb,
          emiFromDb,
          sipFromDb,
          stepupSipFromDb,
          interestFromDB,
        ] = await Promise.all([
          fetchTitles(),
          fetchLoans(),
          fetchRecurringDeposits(),
          fetchSWP(),
          fetchFDs(),
          fetchgoalSIP(),
          fetchEMIs(),
          fetchSIPs(),
          fetchStepUpSIPs(),
          fetchInterestCalculations(),
        ]);

        setTitles(titlesFromDb);
        setLoans(loansFromDb);
        setRecurringDeposits(depositsFromDb);
        setSWPS(swpsFromDb);
        setFixedDeposit(fixedFromDb);
        setGoalSIP(goalSipFromDb);
        setEmi(emiFromDb);
        setSIP(sipFromDb);
        setStepUpSIP(stepupSipFromDb);
        setInterest(interestFromDB);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    getData();
  }, []);


  const handleCardClick = (calculation: Title) => {
    const route = calculation.route || "/lumpsum-calculator.html";
    navigate(route, {
      state: { calculation, currencySymbol: calculation.currencySymbol },
    });
  };

  const handlegoalSIPClick = (goalSip: GoalSIPData) => {
    const route = goalSip.route || "/goal-sip-calculator.html";
    navigate(route, {
      state: { goalSip, currencySymbol: goalSip.currencySymbol },
    });
  };

  const handleLoanClick = (loan: LoanData) => {
    const route = loan.route || "/loan-comparision-calculator.html";
    navigate(route, { state: { loan, currencySymbol: loan.currencySymbol } });
  };

  const handleInterestCardClick = (interest: InterestCalculation) => {
    const route = interest.route || "/interestCalculator.html";
    navigate(route, {
      state: { simpleInterest:interest, currencySymbol: interest.currencySymbol },
    });
  };

  const handleRDClick = (deposit: RecurringDeposit) => {
    const route = deposit.route || "/recurring-deposit.html";
    navigate(route, {
      state: { recurring: deposit, currencySymbol: deposit.currencySymbol }, 
    });
  };
  

  const handleFDCardClick = (fixedDeposit: FixedDeposit) => {
    const route = fixedDeposit.route || "/fixed-deposit-calculator.html"; 
    navigate(route, {
      state: {
        fixed: fixedDeposit, 
        currencySymbol: fixedDeposit.currencySymbol,
      },
    });
  };


  const handleSIPClick = (sip: SIP) => {
    const route = sip.route || "/sip-calculator.html";
    navigate(route, { state: { sip, currencySymbol: sip.currencySymbol } });
  };

  const handleSWPClick = (swp: SWPData) => {
    const route = swp.route || "/swp-calculator.html";
    navigate(route, { state: { swp, currencySymbol: swp.currencySymbol } });
  };


  const handleEmiCardClick = (emi: EMI) => {
    const route = emi.route || "/emi-calculator.html";
    navigate(route, {
      state: { emi, currencySymbol: emi.currencySymbol },
    });
  };

  const handleStepUpSIPCardClick = (stepSip: StepUpSIP) => {
    const route = stepSip.route || "/stepup-sip-calculator.html";
    navigate(route, {
      state: { stepSip, currencySymbol: stepSip.currencySymbol },
    });
  };


  const handleDelete = async (type:DeleteType, id:number) => {
    let deleteFunction;

    switch (type) {
      case 'title':
        deleteFunction = deleteTitle;
        setTitles(titles.filter((title) => title.id !== id));
        break;
      case 'loan':
        deleteFunction = deleteLoan;
        setLoans(loans.filter((loan) => loan.id !== id));
        break;
      case 'recurringDeposit':
        deleteFunction = deleteRecurringDeposit;
        setRecurringDeposits(recurringDeposits.filter((deposit) => deposit.id !== id));
        break;
      case 'sip':
        deleteFunction = deleteSIP;
        setSIP(SIPs.filter((sip) => sip.id !== id));
        break;
      case 'swp':
        deleteFunction = deleteSWP;
        setSWPS(swps.filter((swp) => swp.id !== id));
        break;
      case 'fixedDeposit':
        deleteFunction = deleteFD;
        setFixedDeposit(fixedDeposits.filter((fixedDeposit) => fixedDeposit.id !== id));
        break;
      case 'goalSIP':
        deleteFunction = deletegoalSIP;
        setGoalSIP(goalSips.filter((goalsip) => goalsip.id !== id));
        break;
      case 'emi':
        deleteFunction = deleteEMI;
        setEmi(EMIs.filter((emi) => emi.id !== id));
        break;
      case 'stepUpSIP':
        deleteFunction = deleteStepUpSIP;
        setStepUpSIP(StepUpSIPs.filter((stepSip) => stepSip.id !== id));
        break;
      case 'interest':
        deleteFunction = deleteInterestCalculation;
        setInterest(interests.filter((interest) => interest.id !== id));
        break;
      default:
        throw new Error('Invalid delete type');
    }

    await deleteFunction(id);
    setSnackbarOpen(false); 
  };


  const handleDeleteClick = (type: DeleteType, id: number) => {
    setItemIdToDelete(id);
    setDeleteType(type);
    setSnackbarOpen(true);
  };

  const handleConfirmDelete = () => {
    if (itemIdToDelete !== null && deleteType) {
      handleDelete(deleteType, itemIdToDelete);
    }
  };

  const handleCancelDelete = () => {
    setSnackbarOpen(false);
    setItemIdToDelete(null);
    setDeleteType(null);
  };

  return (
    <div className="container mt-5">
      <Typography variant="h5" gutterBottom >
        {/* Saved Calculations */}
      </Typography>
      <Grid container spacing={2}>
        {titles.length === 0 &&
          loans.length === 0 &&
          swps.length === 0 &&
          fixedDeposits.length === 0 &&
          recurringDeposits.length === 0 &&
          SIPs.length === 0 &&
          goalSips.length === 0 &&
          EMIs.length === 0 &&
          StepUpSIPs.length === 0 &&
          interests.length === 0 ? (
          <Grid item xs={12}>
            <Card>
              <CardContent>
                <Typography variant="body1" className="header">
                  No saved calculations found.
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        ) : (
          <>
            {titles.map((calculation) => (
              <Grid item xs={12} md={4} key={calculation.id}>
                <Card
                  onClick={() => handleCardClick(calculation)}
                  className="card-hover" 
                  style={{ cursor: "pointer" }}
                  onMouseEnter={() => setHoveredLumsumId(calculation.id!)}
                  onMouseLeave={() => setHoveredLumsumId(null)}
                >
                  <CardContent style={{ position: "relative" }}>
                    <Typography variant="h6" component="div">
                      Lumpsum:{calculation.title}
                    </Typography>
                    <Typography variant="body2">
                      Principal Amount: {calculation.principal}
                    </Typography>
                    <Typography variant="body2">
                      Expected Annual Return Rate: {calculation.rate}%
                    </Typography>
                    <Typography variant="body2">
                      Investment Period (Years): {calculation.period}
                    </Typography>

                    {hoveredLumsumId === calculation.id && (
                      <IconButton
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteClick('title',calculation.id);
                        }}
                        style={{ position: "absolute", right: 10, top: 10 }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    )}
                  </CardContent>
                </Card>
              </Grid>
            ))}
            {loans.map((loan) => (
              <Grid item xs={12} md={4} key={loan.id}>
                <Card
                  onClick={() => handleLoanClick(loan)}
                  className="card-hover" 
                  style={{ cursor: "pointer", minHeight:'135px'}}
                  onMouseEnter={() => setHoveredLoanId(loan.id!)}
                  onMouseLeave={() => setHoveredLoanId(null)}
                >
                  <CardContent style={{ position: "relative" }}>
                    <Typography variant="h6" component="div">
                      Loan Compare:{loan.title}
                    </Typography>
                    <Typography variant="body2">
                      Loan 1 Amount: {loan.loan1Amount}
                    </Typography>
                    <Typography variant="body2">
                      Loan 2 Amount: {loan.loan2Amount}
                    </Typography>

                    {hoveredLoanId === loan.id && (
                      <IconButton
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteClick('loan',loan.id);
                        }}
                        style={{ position: "absolute", right: 10, top: 10 }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    )}
                  </CardContent>
                </Card>
              </Grid>
            ))}
            {recurringDeposits.map((deposit) => (
              <Grid item xs={12} md={4} key={deposit.id}>
                <Card
                  onClick={() => handleRDClick(deposit)}
                  className="card-hover" 
                  style={{ cursor: "pointer" }}
                  onMouseEnter={() => setHoveredRDId(deposit.id!)}
                  onMouseLeave={() => setHoveredRDId(null)}
                >
                  <CardContent style={{ position: "relative" }}>
                    <Typography variant="h6" component="div">
                      Recurring Deposit:{deposit.title}
                    </Typography>
                    <Typography variant="body2">
                      Deposit Amount: {deposit.depositAmount}
                    </Typography>
                    <Typography variant="body2">
                      Interest Rate: {deposit.rate}%
                    </Typography>
                    <Typography variant="body2">
                      Investment Period: {deposit.period}
                    </Typography>

                    {hoveredRDId === deposit.id && (
                      <IconButton
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteClick('recurringDeposit', deposit.id);
                        }}
                        style={{ position: "absolute", right: 10, top: 10 }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    )}
                  </CardContent>
                </Card>
              </Grid>
            ))}

            {swps.map((swp) => (
              <Grid item xs={12} md={4} key={swp.id}>
                <Card
                  onClick={() => handleSWPClick(swp)}
                  className="card-hover" 
                  style={{ cursor: "pointer" }}
                  onMouseEnter={() => setHoveredSWPId(swp.id!)}
                  onMouseLeave={() => setHoveredSWPId(null)}
                >
                  <CardContent style={{ position: "relative" }}>
                    <Typography variant="h6" component="div">
                      SWP:{swp.title}
                    </Typography>
                    <Typography variant="body2">
                      Initial Investment: {swp.initialInvestment}
                    </Typography>
                    <Typography variant="body2">
                      Monthly Withdrawal: {swp.monthlyWithdrawal}
                    </Typography>
                    <Typography variant="body2">Rate: {swp.rate}</Typography>

                    {hoveredSWPId === swp.id && (
                      <IconButton
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteClick('swp',swp.id);
                        }}
                        style={{ position: "absolute", right: 10, top: 10 }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    )}
                  </CardContent>
                </Card>
              </Grid>
            ))}

            {fixedDeposits.map((fixedDeposit) => (
              <Grid item xs={12} md={4} key={fixedDeposit.id}>
                <Card
                  onClick={() => handleFDCardClick(fixedDeposit)}
                  className="card-hover" 
                  style={{ cursor: "pointer" }}
                  onMouseEnter={() => setHoveredFDId(fixedDeposit.id!)}
                  onMouseLeave={() => setHoveredFDId(null)}
                >
                  <CardContent style={{ position: "relative" }}>
                    <Typography variant="h6" component="div">
                      Fixed Deposit:{fixedDeposit.title}
                    </Typography>
                    <Typography variant="body2">
                      Principal Amount: {fixedDeposit.principal}
                    </Typography>
                    <Typography variant="body2">
                      Rate: {fixedDeposit.rate}%
                    </Typography>
                    <Typography variant="body2">
                      Period: {fixedDeposit.period}
                    </Typography>

                    {hoveredFDId === fixedDeposit.id && (
                      <IconButton
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteClick('fixedDeposit',fixedDeposit.id,);
                        }}
                        style={{ position: "absolute", right: 10, top: 10 }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    )}
                  </CardContent>
                </Card>
              </Grid>
            ))}

            {goalSips.map((goalsip) => (
              <Grid item xs={12} md={4} key={goalsip.id}>
                <Card
                  onClick={() => handlegoalSIPClick(goalsip)}
                  className="card-hover" 
                  style={{ cursor: "pointer" }}
                  onMouseEnter={() => setHoveredSipGoalId(goalsip.id!)}
                  onMouseLeave={() => setHoveredSipGoalId(null)}
                >
                  <CardContent style={{ position: "relative" }}>
                    <Typography variant="h6" component="div">
                      Goal SIP:{goalsip.title}
                    </Typography>
                    <Typography variant="body2">
                      Goal Amount: {goalsip.goalAmount}
                    </Typography>
                    <Typography variant="body2">
                      Duration: {goalsip.duration}
                    </Typography>
                    <Typography variant="body2">
                      Rate of Return: {goalsip.rateOfReturn}
                    </Typography>

                    {hoveredSipGoalId === goalsip.id && (
                      <IconButton
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteClick('goalSIP', goalsip.id);
                        }}
                        style={{ position: "absolute", right: 10, top: 10 }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    )}
                  </CardContent>
                </Card>
              </Grid>
            ))}

            {EMIs.map((emi) => (
              <Grid item xs={12} md={4} key={emi.id}>
                <Card
                  onClick={() => handleEmiCardClick(emi)}
                  className="card-hover" 
                  style={{ cursor: "pointer" }}
                  onMouseEnter={() => setHoveredEmiId(emi.id!)}
                  onMouseLeave={() => setHoveredEmiId(null)}
                >
                  <CardContent style={{ position: "relative" }}>
                    <Typography variant="h6" component="div">
                      EMI:{emi.title}
                    </Typography>
                    <Typography variant="body2">
                      Principal Amount: {emi.amount}
                    </Typography>
                    <Typography variant="body2">
                      Interest rate: {emi.interest}%
                    </Typography>
                    <Typography variant="body2">
                      Loan Period : {emi.period}
                    </Typography>

                    {hoveredEmiId === emi.id && (
                      <IconButton
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteClick('emi',emi.id);
                        }}
                        style={{ position: "absolute", right: 10, top: 10 }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    )}
                  </CardContent>
                </Card>
              </Grid>
            ))}

            {SIPs.map((sip) => (
              <Grid item xs={12} md={4} key={sip.id}>
                <Card
                  onClick={() => handleSIPClick(sip)}
                  className="card-hover" 
                  style={{ cursor: "pointer" }}
                  onMouseEnter={() => setHoveredSipId(sip.id!)}
                  onMouseLeave={() => setHoveredSipId(null)}
                >
                  <CardContent style={{ position: "relative" }}>
                    <Typography variant="h6" component="div">
                      Sip:{sip.title}
                    </Typography>
                    <Typography variant="body2">
                      Monthly Investment: {sip.monthlyInvestment}
                    </Typography>
                    <Typography variant="body2">
                      Expected Annual Return Rate: {sip.rate}
                    </Typography>
                    <Typography variant="body2">
                      Period: {sip.period}
                    </Typography>

                    {hoveredSipId === sip.id && (
                      <IconButton
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteClick('sip',sip.id);
                        }}
                        style={{ position: "absolute", right: 10, top: 10 }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    )}
                  </CardContent>
                </Card>
              </Grid>
            ))}

            {StepUpSIPs.map((stepSip) => (
              <Grid item xs={12} md={4} key={stepSip.id}>
                <Card
                  onClick={() => handleStepUpSIPCardClick(stepSip)}
                  className="card-hover" 
                  style={{ cursor: "pointer" }}
                  onMouseEnter={() => setHoveredStepupId(stepSip.id!)}
                  onMouseLeave={() => setHoveredStepupId(null)}
                >
                  <CardContent style={{ position: "relative" }}>
                    <Typography variant="h6" component="div">
                      Step Up SIP:{stepSip.title}
                    </Typography>
                    <Typography variant="body2">
                      Monthly Investment: {stepSip.monthlyDeposit}
                    </Typography>
                    <Typography variant="body2">
                      Annual Step UP : {stepSip.stepUpPercent}
                    </Typography>
                    {/* <Typography variant="body2">
                      Interest Rate : {stepSip.interestRate}
                    </Typography> */}
                    <Typography variant="body2">
                      Period: {stepSip.timePeriod}
                    </Typography>

                    {hoveredStepupId === stepSip.id && (
                      <IconButton
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteClick('stepUpSIP',stepSip.id);
                        }}
                        style={{ position: "absolute", right: 10, top: 10 }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    )}
                  </CardContent>
                </Card>
              </Grid>
            ))}

            {interests.map((interest) => (
              <Grid item xs={12} md={4} key={interest.id}>
                <Card
                  onClick={() => handleInterestCardClick(interest)}
                  className="card-hover" 
                  style={{ cursor: "pointer" }}
                  onMouseEnter={() => setHoveredIntId(interest.id!)}
                  onMouseLeave={() => setHoveredIntId(null)}
                >
                  <CardContent style={{ position: "relative" }}>
                    <Typography variant="h6" component="div">
                      Interest:{interest.title}
                    </Typography>
                    <Typography variant="body2">
                      Monthly Investment: {interest.principal}
                    </Typography>
                    <Typography variant="body2">
                      Interest Rate : {interest.rate}
                    </Typography>
                    <Typography variant="body2">
                      Period : {interest.period}
                    </Typography>

                    {hoveredIntId === interest.id && (
                      <IconButton
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation();
                          handleDeleteClick('interest',interest.id);
                        }}
                        style={{ position: "absolute", right: 10, top: 10 }}
                      >
                        <DeleteIcon />
                      </IconButton>
                    )}
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </>
        )}
      </Grid>
      <DeleteSnackbar
        open={snackbarOpen}
        message="Are you sure you want to delete this calculation?"
        onConfirm={handleConfirmDelete}
        onCancel={handleCancelDelete}
        onClose={handleCancelDelete}
      />
    </div>
  );
};

export default SavedCalculations;
